const gfChartOption = {
	chart: {
		type: 'column',
	},
	title: {
		text: ''
	},
	credits: {
		enabled: false
	},
	subtitle: {
		text: ''
	},
	exporting: {
		enabled: false,
		url: '//export.highcharts.com.cn'
	},
	xAxis: {
		type: 'category',
		labels: {
			rotation: -45  // 设置轴标签旋转角度
		},

		title: {
			enabled: true,
			text: '单位：μm'
		}
	},
	yAxis: {
		min: 0,
		title: {
			text: 'ug/m³'
		},
		endOnTick: false,
		startOnTick: false,
		// tickInterval: 4

	},
	legend: {
		enabled: false
	},
	tooltip: {
		pointFormat: '<b>{point.y:.1f} ug/m³</b>'
	},
	series: [{
		name: '',
		data: [],
		dataLabels: {
			enabled: true,
			rotation: -90,
			color: '#FFFFFF',
			align: 'right',
			y: 10
		}
	}]
}

export { gfChartOption }


// WEBPACK FOOTER //
// ./src/option/optionlipu.js